import type { EnrichedTracker } from '@racemap/sdk/schema/trackers';
import type { Immutable } from 'immer';
import { useStore } from '../../store/reducers';

export function useTrackers(): Immutable<Array<EnrichedTracker>> {
  return Array.from(useStore((s) => s.trackers.items).values());
}
